import { App } from '@capacitor/app';
import { Keyboard } from '@capacitor/keyboard';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import history from 'providers/history';
import tokenService from 'services/tokenService';
import NotificationService from 'services/notificationService';
import store from 'redux/store';
import { authActions } from 'redux/auth';

const onAppLinkOpened = ({ url }) => {
  const { pathname, searchParams } = new URL(url);

  if (searchParams.get('side') === 'directory') {
    history.push('/directory');
    return;
  }

  if (searchParams.get('side') === 'contacts') {
    history.push('/contacts');
    return;
  }

  history.push({ pathname, search: searchParams.toString() });
};

const onFcmToken = async ({ token }) => {
  if (!token) {
    return;
  }
  await tokenService.setFcmToken(token);
  store.dispatch(authActions.deviceTokenReceived());
};

// TalkJS sends chat notifications to iOS devices through APNs directly.
const onApnsToken = async ({ token }) => {
  if (!token) {
    return;
  }
  await tokenService.setApnsToken(token);
  store.dispatch(authActions.deviceTokenReceived());
};

const init = () => {
  Keyboard.addListener('keyboardWillShow', () => document.body.classList.add('has-keyboard-open'));
  Keyboard.addListener('keyboardWillHide', () => document.body.classList.remove('has-keyboard-open'));

  App.addListener('appUrlOpen', onAppLinkOpened);

  FirebaseMessaging.addListener('tokenReceived', onFcmToken);
  FirebaseMessaging.addListener('apnsTokenReceived', onApnsToken);
  FirebaseMessaging.addListener('notificationActionPerformed', ({ notification }) => {
    NotificationService.onNotificationClick({ data: notification.data });
  });
  FirebaseMessaging.getToken().then(onFcmToken).catch(error => console.warn('No FCM token yet', error));
};

export default init;
